import React from 'react';
import PropTypes from 'prop-types';
import { get, reject } from 'lodash';

import DateWithHover from 'components/timestamps/date_with_hover';

export const NAME = 'contactName';
export const RELATIONSHIP = 'relationshipLabel';
export const ADDRESS = 'address';
export const EMAIL = 'email';
export const PHONE = 'phone';
export const LAST_UPDATED = 'lastUpdated';

export const COLUMN_DEFINITIONS = {
  [NAME]: { title: 'Name', sortValue: 'contactName' },
  [EMAIL]: { title: 'Email', sortValue: 'email' },
  [PHONE]: { title: 'Phone', sortValue: 'mobilePhone' },
  [ADDRESS]: { title: 'Address', sortValue: 'address' },
  [LAST_UPDATED]: { title: 'Last Contacted', sortValue: 'lastUpdated' },
  [RELATIONSHIP]: { title: 'Relation', sortValue: 'relationshipLabel' }
};

export const CONFIGURABLE_COLUMNS = reject(Object.keys(COLUMN_DEFINITIONS), column => column === NAME);

function EmptyCell() {
  return <span>--</span>;
}

function SimpleCell({ content, isDate }) {
  if (!content) return <EmptyCell />;
  if (isDate) return <DateWithHover timestamp={content} />;

  return <React.Fragment>{content}</React.Fragment>;
}
SimpleCell.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  isDate: PropTypes.bool
};

export default function Cell({ contactCompany, columnName }) {
  let cellContent;

  if (Cell[columnName]) {
    const CellComponent = Cell[columnName];
    cellContent = <CellComponent contactCompany={contactCompany} />;
  } else {
    const { sortValue, type } = COLUMN_DEFINITIONS[columnName];
    cellContent = <SimpleCell content={get(contactCompany, sortValue)} isDate={type === 'date'} />;
  }

  return <td>{cellContent}</td>;
}
Cell.propTypes = {
  columnName: PropTypes.string.isRequired,
  contactCompany: PropTypes.object.isRequired
};

function ContactNameCell({ contactCompany }) {
  const name = <strong>{contactCompany.contactName}</strong>;

  return <div className="contact-name" title={contactCompany.contactName}>
    {contactCompany.contactPath ? <a href={contactCompany.contactPath}>{name}</a> : name}
  </div>;
}
ContactNameCell.propTypes = {
  contactCompany: PropTypes.shape({
    contactName: PropTypes.string.isRequired,
    contactPath: PropTypes.string
  }).isRequired
};

Cell[NAME] = ContactNameCell;
